import { render, staticRenderFns } from "./LightBoxInsert.vue?vue&type=template&id=e8c89152"
import script from "./LightBoxInsert?vue&type=script&lang=ts&external"
export * from "./LightBoxInsert?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports